// composables/useApiFetch.ts
export function $api<T>(url: string, options = {}) {
    const sanctumClient = useSanctumClient()

    return sanctumClient<T>(url, {
        ...options,
    })
}
